export const environment = {
  production: false,
  envName: 'dev',
  supabaseUrl: 'https://bpdghozstsjrmdwqohih.supabase.co',
  supabasePublishableKey: 'sb_publishable_DPOPzo_sM1tPiEmC2LIo8g_wqgjWmKD',
  adobePdfClientId: 'ceb31ce539ab4c66a57bc8e266c6f4ac',
  previewBaseDomain: 'despesse.commerce.agileinteractive.eu',
  recaptcha: {
    siteKey: '6Lfu-ZwtAAAAANNayJ4GbVVkzCsdk8WWMc7UATdz',
  },
};
